import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import SendReceiveButton from '../../../../components/SendReceiveButton/SendReceiveButton';
import Tabs from '../../../../components/Tabs/Tabs';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';
import { receiveSlice, sendSlice } from '../../../../store/slices';
import AccountCard from '../AccountCard';
import AccountHistory from '../AccountHistory/AccountHistory';

import './AccountTemplate.scss';

const { routes } = AppConfig;

const AccountTemplate = ({ account, activeCurrency, cardTranslate, headerTransition }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	const goToSend = () => {
		dispatch(sendSlice.actions.setSendData({ asset: activeCurrency, account }));
		navigate(routes.sendPayment, {
			state: { sendStartRouteParams: { search: location.search, hash: location.hash } },
		});
	};

	const goToReceive = () => {
		dispatch(receiveSlice.actions.setReceiveData({ asset: activeCurrency, account }));
		navigate(routes.receiveQR);
	};

	return (
		<div className='AccountTemplate'>
			<div
				className={classNames('AccountTemplate__header', { headerTransition })}
				style={{ transform: `translateX(${cardTranslate}%)` }}
			>
				<AccountCard account={account} activeCurrency={activeCurrency} />
			</div>
			<div className='AccountTemplate__body'>
				<div className='send-receive'>
					<SendReceiveButton type='Send' onClick={goToSend} />
					<SendReceiveButton type='Receive' onClick={goToReceive} />
				</div>

				<Tabs
					items={[
						{
							name: t('History'),
							component: <AccountHistory AddressId={account.AddressId} />,
						},
					]}
				/>
			</div>
		</div>
	);
};

export default AccountTemplate;
